<template>
  <div
    data-test="logic-tree"
    class="pl-2 logic-tree"
    :data-depth="depth"
    :class="{ 'border rounded pt-2': depth===0, 'pb-2': isNode }"
  >
    <div
      class="flex align-center"
      :class="{ 'pb-2': !isNode }"
    >
      <div
        v-if="isNode"
        class="flex-1"
      >
        <slot v-bind="{ value }" />
      </div>
      <div
        v-else
        class="flex-1"
      >
        {{ decamelize(value.condition)  }} of
      </div>
    </div>
    <div
      v-if="!isNode && value.rules.length"
      class="relative"
    >
      <div class="pointer-line border border-r-0 border-t-0" />
      <div
        class="border border-r-0 rounded-l ml-2"
        :style="{ background: depth % 2 === 0 ? '#f5f5f5' : '#ffffff' }"
      >
        <LogicTree
          v-for="(rule,index) in value.rules"
          :key="index"
          :value="rule"
          :depth="depth+1"
          class="pt-2"
          :class="{ 'pb-0': index === value.rules.length-1 && !rule.rules, 'pb-2 border-b': index !== value.rules.length-1}"
        >
          <template #default="{ value: rule }">
            <slot v-bind="{ value: rule }" />
          </template>
        </LogicTree>
      </div>
    </div>
  </div>
</template>

<script>
import { decamelize } from '@/utils/generalUtils'

export default {
  name: 'LogicTree',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isNode() {
      return !this.value.condition
    },
  },
  methods: {
    decamelize,
  },
}
</script>

<style scoped>
.pointer-line {
  position: absolute;
  height: calc(50% + 12px);
  left: 0px;
  width: 8px;
  top: -12px;
}
</style>
